import type { ElementType } from "react"

import { useTranslations } from "next-intl"

import { type ImageCrop, TileImage } from "@/components/ui/tile-image"
import { Link } from "@/i18n/navigation"

export interface ArtBannerItem {
  id: string
  image: string
  imageCrop?: ImageCrop
  imageAlt?: string
  alt: string
  href?: string
  serveId?: string
}

const ArtBanner = ({ item, priority }: { item: ArtBannerItem; priority: boolean }) => {
  const t = useTranslations("marketplace.artBanners")
  const href = item.href
  const Card: ElementType = href ? Link : "div"
  return (
    <Card
      {...(href ? { href } : {})}
      aria-label={href && !item.alt.trim() ? t("openLink") : undefined}
      data-nelo-serve={item.serveId}
      className="press bg-surface-muted rounded-12x focus-visible:ring-brand @stage:aspect-auto @stage:h-96 relative isolate block aspect-video overflow-hidden focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
    >
      <TileImage src={item.image} crop={item.imageCrop} alt="" fill sizes="96vw" className="@stage:block hidden scale-125 object-cover blur-2xl" />
      <TileImage
        src={item.image}
        crop={item.imageCrop}
        alt={item.alt}
        fill
        sizes="(min-width: 1008px) 96vw, 100vw"
        priority={priority}
        className="@stage:object-contain object-cover"
      />
    </Card>
  )
}

export const ArtBanners = ({ items, priority = false }: { items: ArtBannerItem[]; priority?: boolean }) => (
  <div className="@container">
    <div className="mx-gut flex flex-col gap-300">
      {items.map((item, index) => (
        <ArtBanner key={item.id} item={item} priority={priority && index === 0} />
      ))}
    </div>
  </div>
)
